import { render, staticRenderFns } from "./QuestionTypeSelector.vue?vue&type=template&id=d961a542"
import script from "./QuestionTypeSelector.vue?vue&type=script&lang=js"
export * from "./QuestionTypeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d961a542')) {
      api.createRecord('d961a542', component.options)
    } else {
      api.reload('d961a542', component.options)
    }
    module.hot.accept("./QuestionTypeSelector.vue?vue&type=template&id=d961a542", function () {
      api.rerender('d961a542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionTypeSelector.vue"
export default component.exports